import React, { Fragment } from "react";

import { Hidden } from "@material-ui/core";
import { PlusCircle } from "react-feather";
import { useHistory } from "react-router-dom";

import { MobileAddButton } from "@hubcapp/components";
import { useTealium } from "@hubcapp/context";
import Button from "@ds-developer/button";

const AddNewLearnerButton: React.FC = () => {
  const { push } = useHistory();
  const { trackEvent } = useTealium();

  const handleNewLearnerButton = () => {
    trackEvent({
      eventCategory: "Learner",
      eventAction: "Button Click",
      eventLabel: "New Learner",
    });
    push("/learners/add");
  };

  return (
    <Fragment>
      <Hidden smUp>
        <MobileAddButton
          data-test="add-new-learner-button"
          onClick={handleNewLearnerButton}
        />
      </Hidden>
      <Hidden xsDown>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<PlusCircle size={14} />}
          onClick={handleNewLearnerButton}
          data-test="add-new-learner-button"
        >
          New Learner
        </Button>
      </Hidden>
    </Fragment>
  );
};

export default AddNewLearnerButton;
